import { types as t } from 'mobx-state-tree';

export const MetaName = t.model('MetaName', {
  'twitter:title': '',
  'twitter:image:src': '',
  'twitter:description': '',
});

export const MetaProperty = t.model('MetaProperty', {
  'og:url': '',
  'og:type': '',
  'og:image': '',
  'og:title': '',
  'og:siteName': '',
  'og:description': '',
});

export default t.model('Meta', {
  name: t.optional(MetaName, {}),
  property: t.optional(MetaProperty, {}),
});
